import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useNotification } from "stories/components/Notification";
import { onApiError } from "services/apiErrorBus";

// One page action can fan out to several requests. Without this window a single
// blocked click would stack four identical toasts.
const DEDUPE_MS = 4000;

/**
 * Turns API errors the interceptor cannot handle on its own into a toast.
 *
 * 403 is the one that matters: the server enforces the `read_only` account role
 * (Sovellon #2260), and before this the request was rejected silently — the view kept
 * its spinner and the user got no explanation.
 */
const ApiErrorNotifier = () => {
  const { notify } = useNotification();
  const { t } = useTranslation();

  useEffect(() => {
    let lastShownAt = 0;

    return onApiError((event) => {
      if (event?.status !== 403) {
        return;
      }
      const now = Date.now();
      if (now - lastShownAt < DEDUPE_MS) {
        return;
      }
      lastShownAt = now;

      notify({
        type: "danger",
        title: t("api_error_forbidden_title", "Toimintoa ei sallittu"),
        message: t(
          "api_error_forbidden_message",
          "Käyttöoikeutesi ei riitä tähän muutokseen. Ota yhteys tilin pääkäyttäjään."
        ),
      });
    });
  }, [notify, t]);

  return null;
};

export default ApiErrorNotifier;
